<div class="summary-offer-widget">
  <span *ngIf="largeLoanProgramOffered" class="product-label">{{productLabel}}</span>
  <h3 [class.large-loan-title]="isLargeLoanProgram">
    {{productName}}
  </h3>
  <mat-card appearance="raised" class="mat-elevation-z4" [ngClass]="{
    'loc-card':  type === offerType.LOC,
    'term-card':  type === offerType.Term,
    'law-card': type === offerType.Law,
    'large-loan-card': isLargeLoanProgram
  }" (click)="detailLink()">
    <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
      <div style="position: relative; z-index:999;" fxLayoutAlign="center center" fxFlex="7">
        <mat-icon *ngIf="type === offerType.LOC && !isLargeLoanProgram" class="mat-white">data_saver_off</mat-icon>
        <mat-icon *ngIf="isLargeLoanProgram" class="mat-white">workspace_premium</mat-icon>
        <mat-icon *ngIf="type === offerType.Term" class="mat-white">assessment</mat-icon>
        <mat-icon *ngIf="type === offerType.Law" class="mat-white">work</mat-icon>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-between left" fxFlex="80">
          <span class="offer-value">{{getAmount() | currency:'$'}}</span>
          <span class="offer-title">{{getAmountTitle()}}</span>
          <span class="offer-value">{{repaymentTermLabel}}</span>
          <span class="offer-title">Repayment term</span>
          <div>
          <button mat-button color="primary" (click)="detailLink()">SEE ALL OFFERS</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <p *ngIf="isLargeLoanProgram" class="bank-integration-notice">{{bankIntegrationNotice}}</p>
</div>
